<template>
	<div class="section-benefits">
		<p class="benefits-title">SÉ PARTE DE NUESTRA RED DE BODEGUEROS AFILIADOS</p>
		<v-layout wrap class="wrapper-points container">
			<v-flex xs12 md6 class="pr-48">
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">1</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-0 text">Tus clientes se descargarán tu APP de Google play.</p>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">2</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-0 text">Tendrás tu usuario y contraseña secreta  para que puedas ingresar al administrador web.</p>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">3</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-0 text">Podrás realizar dos tipos de entrega: El recojo en tienda y la entrega de pedidos a domicilio (delivery).</p>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">4</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-0 text">Podrás administrar todo desde tu computadora o celular.</p>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">5</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-0 text">Gestionar tus productos, cambiar precios, agregar un nuevo producto o modificarlo.</p>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md6 class="pl-48">
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">6</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-4 text">El servicio de implementación incluye:</p>
						<div>
							<v-layout class="mb-text">
								<v-flex xs1>
									<div>
										<img 
											src="https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png" 
											alt="check"
											class="check">
									</div>
								</v-flex>
								<v-flex xs11 pl-2>
									<p class="mb-0 sub-text">3 horas de soporte por voz</p>
								</v-flex>
							</v-layout>
							<v-layout class="mb-text">
								<v-flex xs1>
									<div>
										<img 
											src="https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png" 
											alt="check"
											class="check">
									</div>
								</v-flex>
								<v-flex xs11 pl-2>
									<p class="mb-0 sub-text">La carga de la base de datos de tus productos a la plataforma.</p>
								</v-flex>
							</v-layout>
							<v-layout class="mb-text">
								<v-flex xs1>
									<div>
										<img 
											src="https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png" 
											alt="check"
											class="check">
									</div>
								</v-flex>
								<v-flex xs11 pl-2>
									<p class="mb-0 sub-text">Soporte por correo ilimitado.</p>
								</v-flex>
							</v-layout>
						</div>
					</v-flex>
				</v-layout>
				<v-layout wrap mb-4>
					<v-flex xs1>
						<div class="number">7</div>
					</v-flex>
					<v-flex xs11 pl-3>
						<p class="mb-4 text">
							Acceder a nuestra promoción desde <a :href="hrefHere" target="_blank" class="href-here">aquí</a> (en caso apliques):
						</p>
						<div>
							<v-layout class="mb-text">
								<v-flex xs1>
									<div>
										<img 
											src="https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png" 
											alt="check"
											class="check">
									</div>
								</v-flex>
								<v-flex xs11 pl-2>
									<p class="mb-0 sub-text">
										{{ creditQuantity }} pedicréditos en pedidos = {{ creditQuantity }} pedidos sin costo = {{ currencySymbol }}{{ creditTotal | round }} de regalo
									</p>
								</v-flex>
							</v-layout>
							<v-layout>
								<v-flex xs1>
									<div>
										<img 
											src="https://mibodega.s3-sa-east-1.amazonaws.com/chek-greenlight.png" 
											alt="check"
											class="check"
										/>
									</div>
								</v-flex>
								<v-flex xs11 pl-2>
									<p class="mb-0 sub-text">
										1 pedicrédito = {{ currencySymbol }}{{ creditValue | round }} pedido através de aplicativo.
									</p>
								</v-flex>
							</v-layout>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</div>
</template>
<script>
function currencySymbol() {
	return this.isPeru ? 'S/' : '$';
}

function creditTotal() {
	return Number(this.creditQuantity) * Number(this.creditValue);
}

function hrefHere() {
	return this.isPeru ? 'https://registro.mibodega.net/' : 'https://registro-ec.mibodega.net/';
}

function data() {
	return {
		creditQuantity:	process.env.CREDIT_QUANTITY,
		creditValue: process.env.CREDIT_VALUE,
	};
}

export default {
	name: 'section-benefits',
	computed: {
		creditTotal,
		currencySymbol,
		hrefHere,
	},
	data,
};
</script>
<style lang="scss" scoped>
	.section-benefits {
		background-color: color(back-gray-l);
		padding: 81px 7% 102px 7%;
	}

	.benefits-title {
		color: color(green-dark);
		font-family: font(lato-regular);
		font-size: size(large30);
		font-weight: weight(w900);
		margin-bottom: 50px;
		text-align: center;

		@media (max-width: 936px) {
			font-size: size(large);
		}
	}

	.wrapper-points {
		background-color: color(white);
		box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.06);
		border-radius: 20px;
		padding: 83px 70px;

		@media (max-width: 936px) {
			padding: 47px 20px;
		}
	}

	.number {
		background-color: color(back-green);
		border-radius: 50%;
		color: color(title-green);
		font-size: size(medium18);
		font-weight: 600;
		height: 34px;
		padding-top: 4px;
		text-align: center;
		width: 34px;
	}

	.text {
		color: color(form-grey);
		font-size: size(medium20);
		line-height: 25px;

		@media (max-width: 936px) {
			font-size: size(medium16);
		}
	}

	.sub-text {
		color: color(form-grey);
		font-size: size(medium18);

		@media (max-width: 936px) {
			font-size: size(medium16);
		}
	}

	.mb-text {
		margin-bottom: 16px;
	}

	.pr-48 {
		padding-right: 48px;

		@media (max-width: 936px) {
			padding-right: 0;
		}
	}

	.pl-48 {
		padding-left: 48px;

		@media (max-width: 936px) {
			padding-left: 0;
		}
	}

	.check {
		@media (max-width: 936px) {
			height: 22px;
		}
	}

	.href-here {
		color: color(title-green);
		font-size: size(medium20);
		font-weight: weight(w900);
	}
</style>


// WEBPACK FOOTER //
// src/components/generate-app/section-benefits.vue